import {useAppSelector} from '@/hooks';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {TranscriptItemObject} from '@PosterWhiteboard/items/transcript-item/transcript-item.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {SubtitleObject} from '@PosterWhiteboard/items/transcript-item/subtitle/subtitle.types';

export function useGetActiveTranscriptItemSubtitlesHashmap(): Record<string, SubtitleObject> | undefined {
  const activeItemId = useSingleActivePosterItemId();

  return useAppSelector((state) => {
    if (!activeItemId) {
      return undefined;
    }

    const pages = state.posterEditor.posterObject?.pages.pagesHashMap;
    if (!pages) {
      return undefined;
    }

    for (const page of Object.values(pages)) {
      const item = page.items.itemsHashMap[activeItemId];
      if (item && item.gitype === ITEM_TYPE.TRANSCRIPT) {
        return (item as TranscriptItemObject).subtitlesHashmap;
      }
    }

    return undefined;
  });
}
